import Icon, { LinkOutlined, SearchOutlined } from '@ant-design/icons';
import {
  queryProjectList,
  subjectMatterCheckAi,
  subjectMatterMark
} from '@api/announcement';
import ZeissButton from '@components/button';
import ZeissInput from '@components/input';
import ZeissModal from '@components/zeiss-modal';
import { getDomianRelativeUrl } from '@utils/tool';
import {
  Col,
  Collapse,
  Empty,
  Form,
  Radio,
  Row,
  Space,
  Tag,
  message
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useRef, useState } from 'react';
import { useImmer } from 'use-immer';
import { caretSvg } from '../RelatedAnnouncement/data';
import { RelationProjectInterface } from '@views/pages/AnnouncementDetails/type';
export const RepeatMatterPopup = ({
  open,
  handleCancel,
  details,
  getAnnInfo
}: any) => {
  const [currentCheckProject, setCurrentCheckProject] = useState<string | null>(
    null
  );
  const [project, setProject] = useImmer<RelationProjectInterface[]>([]);
  const [aiCheckVisible, setAiCheckVisible] = useState(false);
  const [form] = Form.useForm();
  const inputFilterRef = useRef<any>(null);
  const onFinish = async () => {
    if (!currentCheckProject) {
      return message.error('请选择关联项目');
    }
    const aiCheckRes = await subjectMatterCheckAi({
      subjectMatterCode: details.subjectMatterCode,
      noticeProjectCode: currentCheckProject || ''
    });
    if (!aiCheckRes) {
      setAiCheckVisible(true);
    } else {
      confirmAssociation();
    }
  };

  const confirmAssociation = async () => {
    await subjectMatterMark({
      noticeCode: details.noticeCode,
      subjectMatterCodes:
        details.subjectMatterCode && details.subjectMatterCode.split(','),
      action: 6,
      subjectMatterStatus: 3,
      subjectMatterStatusValue: '重复',
      subjectMatterRemark: form.getFieldValue('subjectMatterRemark'),
      repetitionProjectCode: `${currentCheckProject}`
    });
    message.success('已完成标记');
    setAiCheckVisible(false);
    handleCancel && handleCancel();
    getAnnInfo && getAnnInfo();
  };

  const handleInputSubmit = async () => {
    const keyword = inputFilterRef.current?.input?.value || '';
    if (keyword) {
      const res = await queryProjectList({
        keyword,
        dataFlag: details.dataFlag
      });
      setProject(res?.projects || []);
    }
  };

  const handleChangeProject = (code: string) => {
    setCurrentCheckProject(code);
  };
  const onProjectClick = (e: any, data: any) => {
    e.stopPropagation();
    e.preventDefault();
    goToDetailPage(data);
  };

  const goToDetailPage = (record: any) => {
    window.open(
      `${getDomianRelativeUrl()}/projectList/projectDetail?noticeProjectCode=` +
        record?.noticeProjectCode
    );
  };

  return (
    <>
      <ZeissModal
        open={open}
        width={730}
        centered
        footer={null}
        onCancel={handleCancel}
      >
        <div className="pc-subLayout">
          <div className="pc-sub-title">关联项目</div>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              label={'请选出与你创建的项目相关联的项目：'}
              name={'projectName'}
              // rules={[{ required: true }]}
            >
              <ZeissInput
                placeholder="请输入公告名称、信息标题、客户单位、标的物名称进行查询"
                allowClear
                ref={inputFilterRef}
                style={{ width: 410 }}
                onPressEnter={handleInputSubmit}
                // suffix={<SearchOutlined onClick={handleInputSubmit} />}
              />
              <ZeissButton
                type="primary"
                style={{ margin: '0 10px' }}
                icon={<SearchOutlined />}
                onClick={handleInputSubmit}
              />
            </Form.Item>
            {!project.length ? (
              <Empty description="暂无关联项目可选" />
            ) : (
              <div
                className="pc-repeatMatterP-project-scrollArea"
                style={{
                  height: project.length > 5 ? 365 : 'auto',
                  minHeight: 150
                }}
              >
                <Collapse
                  ghost
                  expandIconPosition="start"
                  expandIcon={({ isActive }) => (
                    <Icon
                      component={caretSvg}
                      className={`${
                        isActive ? '' : 'collapse-active'
                      } collapse_icon`}
                    />
                  )}
                  items={project.map((x: any, index: number) => ({
                    key: String(x.noticeProjectCode || index),
                    label: (
                      <div className="pc-repeatMatterP-project">
                        <div className="project-left">
                          <div
                            className="project_name"
                            onClick={(e) => onProjectClick(e, x)}
                          >
                            <LinkOutlined />
                            <span className="list_projectName_text">
                              {x.projectName}
                            </span>
                          </div>
                          <div className="subject-matter_name">
                            <Tag className="matter-tag">
                              {x.subjectMatterProjectName || ''}
                            </Tag>
                          </div>
                          <div className="subject-matter_ai">
                            <Tag className="matter-tag">
                              {x.classTypeValue || ''}
                            </Tag>
                          </div>
                        </div>
                        <Radio
                          style={{ paddingLeft: 6 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleChangeProject(x.noticeProjectCode);
                          }}
                          checked={currentCheckProject === x.noticeProjectCode}
                        />
                      </div>
                    ),
                    children: (
                      <Row gutter={[16, 8]} className="detail-row">
                        <Col span={12}>
                          <span className="item_row_label">产品线：</span>
                          <span className="item_row_value">
                            {x.projectProductLineValueStr}
                          </span>
                        </Col>
                        <Col span={12}>
                          <span className="item_row_label">
                            标的物总价(万元)：
                          </span>
                          <span className="item_row_value">
                            {x.totalAmount
                              ? x.totalAmount + ' ' + x.totalAmountCurrencyValue
                              : ''}
                          </span>
                        </Col>
                        <Col span={12}>
                          <span className="item_row_label">品牌：</span>
                          <span className="item_row_value">
                            {x.projectBrandValueStr}
                          </span>
                        </Col>
                        <Col span={12}>
                          <span className="item_row_label">OPPID：</span>
                          <span className="item_row_value">{x.oppId}</span>
                        </Col>
                      </Row>
                    )
                  }))}
                />
              </div>
            )}
            <Form.Item
              label={'备注：'}
              name={'subjectMatterRemark'}
              rules={[{ required: true }]}
            >
              <TextArea placeholder="如重复请填写重复" rows={3} />
            </Form.Item>
            <Space className="pc-matter-createAnn-footer" size="middle">
              <ZeissButton
                className="pc-createAnn-cancel"
                onClick={handleCancel}
              >
                取消
              </ZeissButton>
              <ZeissButton
                type="primary"
                className="pc-createAnn-sales"
                htmlType="submit"
              >
                完成标记
              </ZeissButton>
            </Space>
          </Form>
        </div>
      </ZeissModal>
      <ZeissModal
        open={aiCheckVisible}
        width={520}
        centered
        footer={null}
        onCancel={() => setAiCheckVisible(false)}
      >
        <div className="pc-subLayout">
          <div className="pc-sub-title">关联项目</div>
          <div className="ai-check-content">
            <span>
              当前标的物的AI分类与该项目下已关联标的物的AI分类不一致，是否确认关联？
            </span>
          </div>
          <Space className="pc-matter-createAnn-footer" size="middle">
            <ZeissButton
              className="pc-createAnn-cancel"
              onClick={() => setAiCheckVisible(false)}
            >
              取消
            </ZeissButton>
            <ZeissButton
              type="primary"
              className="pc-createAnn-sales"
              onClick={() => {
                setAiCheckVisible(false);
                confirmAssociation();
              }}
            >
              确认关联
            </ZeissButton>
          </Space>
        </div>
      </ZeissModal>
    </>
  );
};
